import { isElementNode, isPhrasingElement } from 'anodum';
import isColoredElement from './is-colored-element';
import isDecorationElement from './is-decoration-element';

const isInlineElement = (element) => {
  if (!isElementNode(element)) return false;

  if (isColoredElement(element) || isDecorationElement(element)) {
    return true;
  }

  const displayStyle = element.style.display;
  if (!displayStyle) {
    return isPhrasingElement(element);
  }
  return displayStyle.includes('inline');
};

export default isInlineElement;
